import { Text } from "@ttc3k/trekker";
import { CollapsableStep } from "widgets/booker/shared";
import { getOverriddenAddOnsDescription } from "widgets/booker/shared/utils";
import { useBookerContext, useCartContext } from "widgets/booker/contexts";
import { useAddOns } from "./useAddOns";
import { AddOnItem } from "./AddOnItem";
import { useAddOnDetailsComplete } from "./useAddOnDetailsComplete";
import { useTranslation } from "react-i18next";

export const AddOns = () => {
  const { cart } = useCartContext();
  const { booker, language } = useBookerContext();
  const mainProductId = cart.length > 0 ? cart[0].productId : null
  const { addOns, error, loading } = useAddOns(mainProductId);
  const detailsComplete = useAddOnDetailsComplete();

  const { t } = useTranslation("booker", { keyPrefix: "ADD_ONS" });

  if (!!error && !loading) {
    throw new Error("Error loading add-ons");
  }

  if (!loading && (!addOns || addOns.length < 1)) {
    return null;
  }

  return (
    // Add-ons are optional; the step only blocks on required details of a
    // selected add-on.
    <CollapsableStep
      title={t("TITLE")}
      complete={detailsComplete}
      optionalStep
      stepId="add-ons"
    >
      <Text color="text.mid" whiteSpace="pre-line">
        {getOverriddenAddOnsDescription(booker, t("SUBTITLE"), language)}
      </Text>
      {addOns.map((p, i) => (
        <AddOnItem addOn={p} key={p?._id ?? i} />
      ))}
    </CollapsableStep>
  );
};
